module.exports = __webpack_public_path__ + "img/instrument-dlja-metalloobrabotki.79ad170f.svg";